module.exports = __webpack_public_path__ + "img/btn_menu_nh_c.1d38aba7.png";